<template>
  <div class="grid-view__cell">
    <div
      class="grid-field-date job-schedule-grid-value"
      :title="`${displayDate}   ${displayTime}`"
    >
      <div class="grid-field-date__date">{{ displayDate }}</div>
      <div class="grid-field-date__time">{{ displayTime }}</div>
    </div>
  </div>
</template>

<script>
import { formatScheduleDate, formatScheduleTime } from "@peninsula/jobSchedule";

export default {
  name: "JobScheduleFunctionalGridField",
  props: {
    field: { type: Object, required: true },
    value: { type: Object, default: null },
  },
  computed: {
    displayDate() {
      return this.value
        ? formatScheduleDate(this.value, this.field.timezone)
        : "";
    },
    displayTime() {
      return this.value
        ? formatScheduleTime(this.value, this.field.timezone)
        : "";
    },
  },
};
</script>

<style scoped>
.job-schedule-grid-value {
  gap: 8px;
}

.job-schedule-grid-value .grid-field-date__date {
  flex: 0 0 auto;
  width: auto;
  overflow: visible;
}

.job-schedule-grid-value .grid-field-date__time {
  flex: 1 1 auto;
  width: auto;
  max-width: none;
  min-width: 0;
  text-align: right;
}
</style>
